// extracted by mini-css-extract-plugin
export default {"p_tye":"e8420d7244","slcted":"_1fb1dfcf40","slc_color":"_7bc1f9c0a0","item_p":"_45240ff0be","r0":"_771697aa00"};